export const validationMessage = {
  REQUIRED: "は必須です。",
  NUM: "は半角数字で入力ください。",
  EMAIL: "有効なメールアドレス形式ではありません。",
  PW_CONFIRM: "パスワードが一致しません。",
  PW_LENGTH: "パスワードは10文字以上です。",
  PW_FORMAT: "大文字英字、小文字英字、数字、記号が各一つ以上必要です。",
  PW_CONFIRM_LOGINID: "ログインIDと同じものは使用できません。",
  ID_FORMAT: "ログインIDは半角英数字のみです。",
  MOBILE_PHONE: "携帯電話の電話番号ではありません。",
  MOBILE_PHONE_FORMAT:
    "ハイフンを含む半角数字で入力してください。例: 090-XXXX-YYYY",
  PHONE_FORMAT: "ハイフンを含む半角数字で入力してください。例: 03-XXXX-YYYY",
  API_KEY_FORMAT: "不正な形式のAPIキーが指定されています。",
  API_SECRET_FORMAT: "不正な形式のAPIシークレットが指定されています。",
  APP_ID_FORMAT: "不正な形式のアプリケーションIDが指定されています。",
  SECRET_KEY_FORMAT: "不正な形式の秘密鍵が指定されています。",
  POSTAL_CODE: "ハイフンを含む半角数字8桁で入力してください。例: 123-4567",
  KANA: "ひらがなで入力してください。",
};

export const errorMessages = {
  CORP_NUM_NOT_VALID: "法人番号が正しく検証されていません。",
  CORP_NUM_NOT_EXIST: "法人番号が存在しません。",
};
